/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import Page from '../screens/page'
import Download from '../screens/download'
import Downloads from '../screens/downloads'
import Notfound from '../screens/notfound'
import Cart from '../screens/cart';
import Home from '../screens/home';
import Logout from '../screens/logout';
import Contact from '../screens/contact';
import Login from '../screens/auth/login';
import Register from '../screens/auth/register';
import ForgottenPassword from "../screens/auth/forgottenPassword";
import RegisterLoginTicket from "../screens/auth/registerLoginTicket";
import ResetPassword from "../screens/auth/resetPassword";
import Addressform from '../screens/addressform';
import Checkout from '../screens/checkout';
import ShopPage from '../screens/shoppage';
import photoUploadComponent from '../components/Photo/photoUploadComponent';
import SuccesPage from '../screens/succes';
import Classes from '../screens/classes';
import ClassCards from '../screens/classcards';
import PhotoLoginShare from '../screens/auth/photoLoginShare';
import Dasboard from '../screens/dasboard';

const shopRoutes = [
  {
    path: ["/login", "/webwinkel/webshop/:login/:hash?/:v2?"],
    component: Login,
    isPrivate: false,
    exact: true,
  },
  {
    path: ["/login", "/webshop/:login/:hash?/:v2?"],
    component: Login,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/shoppage/photo_id/:photo_id/:category_id?',
    component: ShopPage,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/my-downloads',
    component: Downloads,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/dasboard',
    component: Dasboard,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/register',
    component: Register,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/forgotten-password',
    component: ForgottenPassword,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/register-ticket',
    component: RegisterLoginTicket,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/addressform',
    component: Addressform,
    isPrivate: true,
    exact: true,
  },

  {
    path: '/checkout',
    component: Checkout,
    isPrivate: true,
    exact: true,
  },

  {
    path: '/succes/type/:type/',
    component: SuccesPage,
    isPrivate: true,
    exact: true,
  },

  {
    path: '/forward-login',
    component: PhotoLoginShare,
    isPrivate: true,
    exact: true,
  },

  {
    path: '/contact',
    component: Contact,
    isPrivate: false,
    exact: true,
  },

  {
    path: '/cart',
    component: Cart,
    isPrivate: true,
    exact: true,
  },

  {
    path: '/cart/type/:type/',
    component: Cart,
    isPrivate: true,
    exact: true,
  },

  {
    path: '/upload-photo',
    component: photoUploadComponent,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/download/:hash?',
    component: Download,
    isPrivate: false,
    exact: true,
  },
  {
    // path: ["/login", "/webwinkel/webshop/:login/:hash?/:v2?"],
    path: '/classes/:folder_id',
    component: Classes,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/classcards/:school_id/:folder_id',
    component: ClassCards,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/:page',
    component: Page,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/',
    component: Home,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/*',
    component: Notfound,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/logout',
    component: Logout,
    isPrivate: false,
    exact: true,
  }
];

export default shopRoutes;
